import { Injectable } from '@angular/core';
import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { environment } from './../../environments/environment';
import { ErrorService } from './error.service';

@Injectable()
export class ResetPasswordService {
    private url = CommonService.getEwdApiURL() + 'account/resetpassword';

    constructor(
        private http: Http,
        private errorService: ErrorService
        ) {
     }

     reset(resetkey: string, password: string): Observable<Array<any>> {
        let urlSearchParams = new URLSearchParams();
        urlSearchParams.append('resetkey', resetkey);
        urlSearchParams.append('newPassword', password);
        const body = urlSearchParams.toString();
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.url, body, { headers: headers })
            .map((response: Response) => {
                const message = response.json() && response.json().m;
                const success = response.json() && response.json().r;
                return [success, message];
            })
            .catch(this.errorService.handleError);
    }
}
